export const ARCHIVED_STATUS_KEY = 'archived'

export const statusDisplayName = status => {
  if (!status?.name) return ''
  if (!status.system_key || status.name !== status.system_key) return status.name
  const label = status.name.replace(/_/g, ' ')
  return label.charAt(0).toUpperCase() + label.slice(1)
}
